var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThrillerVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.235 14.9045L27.3509 9.77039L23.0258 7.4367L22.4034 2.36481L17.3627 3.98283L13.7532 0L10.3305 3.42275L5.32082 2.7382L4.60515 7.65451L0.0622318 9.77039L1.9603 14.2511L0 19.323L3.85837 21.3144L5.04077 26.324L10.6105 25.8884L13.5665 29L17.5182 25.7017L22.4034 26.4796L23.1502 21.1588L27.4131 19.323L25.235 14.9045ZM13.691 26.573L11.3262 24.0526L6.44099 24.426L5.41416 20.1009L2.24034 18.4828L3.88949 14.22L2.36481 10.6727L6.22318 8.86803L6.84549 4.72961L10.9528 5.2897L13.691 2.5515L16.8026 6.00536L20.9099 4.6985L21.3766 8.55687L25.0794 10.5794L23.2747 14.9667L24.9861 18.4517L21.5322 19.9453L20.8788 24.4571L16.9582 23.8348L13.691 26.573Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8861 16.4604L9.70804 14.5001L8.52563 15.8069L11.9795 18.9496L18.825 11.7619L17.5492 10.5483L11.8861 16.4604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrillerVerifiedIcon);
export default __webpack_public_path__ + "static/media/thrillerVerifiedIcon.69dfe3958a04ab1b76c1e4a109955a4d.svg";
export { ForwardRef as ReactComponent };